import React from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import FieldQty from '../fields/FieldQty';
import ProductVariationListItemPrice from './ProductVariationListItemPrice';
import ProductVariationListItemActionButton from './ProductVariationListItemActionButton';
import { calculateNearestCartQty } from '../../selectors/tagWizardSelector';

function ProductVariationListItem(props) {
    const {
        item,
        cartQty,
        setCartQty,
        currencyFormat,
        currencyDisplayCode,
        locale,
    } = props;
    const {
        ID,
        Title,
        InternalItemID,
        ReSizedProductListingImage,
        SellByPackageOnly = false,
        MinOrderQuantity = 1,
        ExtraInfo,
        IsSale,
        ItemWidth,
        ItemHeight,
        ItemDepth,
        ItemWeight,
    } = item;

    const packSize = MinOrderQuantity;
    const image =
        ReSizedProductListingImage || 'https://via.placeholder.com/80';

    /**
     * Just do a basic set cart qty
     *
     * @param target
     * @param newValue
     */
    const updateCartQty = (target, newValue) => {
        setCartQty(ID, newValue);
    };

    /**
     * Calculate and ensure that the cart qty follows the nearest
     *
     * @param e
     */
    const finaliseCartQty = (e) => {
        const finalCartQty = calculateNearestCartQty(
            SellByPackageOnly,
            cartQty,
            packSize,
            MinOrderQuantity
        );
        setCartQty(ID, finalCartQty);
    };

    return (
        <form
            className='data-table__tr products-data-table-helper__row'
            role='row'
        >
            <div className='data-table__td products-data-table-helper__image'>
                <div className='products-data-table-helper__info-wrapper'>
                    <img src={image} />
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__info'>
                <span className='data-table__info data-table__info--default'>
                    <div className='mini-hint'>{InternalItemID}</div>
                    <div className='product__general-title'>{Title}</div>
                    <div className='product__extra-info tab-content'>
                        <button
                            type='button'
                            className='products-data-table__view-extra-info'
                            data-toggle='product-detail'
                            data-target={`#detailed-view-${ID}`}
                        >
                            <span>
                                <LocalizedMessage id={'VIEW_DETAILS'} />
                            </span>
                        </button>
                        <div className='tab-pane' id={`detailed-view-${ID}`}>
                            <div className='product__extra-info__content'>
                                <div className='text-box text-box--small'>
                                    <ul>
                                        {ItemWidth != '' && (
                                            <li>
                                                <strong>
                                                    <LocalizedMessage
                                                        id={'PRODUCT.WIDTH'}
                                                    />
                                                    :
                                                </strong>{' '}
                                                {ItemWidth} mm
                                            </li>
                                        )}
                                        {ItemHeight != '' && (
                                            <li>
                                                <strong>
                                                    <LocalizedMessage
                                                        id={'PRODUCT.HEIGHT'}
                                                    />
                                                    :
                                                </strong>{' '}
                                                {ItemHeight} mm
                                            </li>
                                        )}
                                        {ItemDepth != '' && (
                                            <li>
                                                <strong>
                                                    <LocalizedMessage
                                                        id={'PRODUCT.DEPTH'}
                                                    />
                                                    :
                                                </strong>{' '}
                                                {ItemDepth} mm
                                            </li>
                                        )}
                                        {ItemWeight != '' && (
                                            <li>
                                                <strong>
                                                    <LocalizedMessage
                                                        id={'PRODUCT.WEIGHT'}
                                                    />
                                                    :
                                                </strong>{' '}
                                                {ItemWeight} grams
                                            </li>
                                        )}
                                        {ExtraInfo &&
                                            ExtraInfo.length > 0 &&
                                            ExtraInfo.map((item, key) => (
                                                <li key={`${ID}-${key}`}>
                                                    <strong>
                                                        {item['Title']}
                                                    </strong>
                                                    {item['Content']}
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
            </div>
            <div className='data-table__td products-data-table-helper__label'>
                <div className='products-data-table-helper__info-wrapper'>
                    {window.loggedIn && IsSale === true && (
                        <div className='product__label product__label--red'>
                            <LocalizedMessage id={'ON_SALE'} />
                        </div>
                    )}
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__qty'>
                <div className='products-data-table-helper__info-wrapper products-data-table-helper__info-wrapper-quantity'>
                    <FieldQty
                        required
                        disabled={
                            window.currentOrderPaymentMethod ==
                                'order-card-authorization-payfast' &&
                            window.isEditOrder
                        }
                        isDisabled={
                            window.currentOrderPaymentMethod ==
                                'order-card-authorization-payfast' &&
                            window.isEditOrder
                        }
                        name='Quantity'
                        value={cartQty}
                        min={MinOrderQuantity || 1}
                        step={SellByPackageOnly === true ? MinOrderQuantity : 1}
                        onChange={updateCartQty}
                        onBlur={finaliseCartQty}
                    />
                    <span className='products-data-table__input-explanation'>
                        <span className='visible-xs visible-sm'>
                            <LocalizedMessage
                                id={'MIN_ORDER_QUANTITY_MOBILE'}
                            />{' '}
                            <strong>{MinOrderQuantity}</strong>
                        </span>
                        <span className='hidden-xs hidden-sm'>
                            <LocalizedMessage
                                id={'MIN_ORDER_QUANTITY_DESKTOP'}
                            />{' '}
                            <strong>{MinOrderQuantity}</strong>
                        </span>
                    </span>
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__unit-price'>
                <div className='products-data-table-helper__info-wrapper products-data-table-helper__info-wrapper-unit-price'>
                    <ProductVariationListItemPrice
                        item={item}
                        cartQty={1}
                        currencyFormat={currencyFormat}
                        currencyDisplayCode={currencyDisplayCode}
                        locale={locale}
                    />
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__price'>
                <div className='products-data-table-helper__info-wrapper products-data-table-helper__info-wrapper-price'>
                    <ProductVariationListItemPrice
                        item={item}
                        cartQty={cartQty}
                        currencyFormat={currencyFormat}
                        currencyDisplayCode={currencyDisplayCode}
                        locale={locale}
                    />
                </div>
            </div>
            <div className='data-table__td products-data-table-helper__action'>
                <div className='products-data-table-helper__info-wrapper'>
                    <div>
                        <ProductVariationListItemActionButton {...props} />
                    </div>
                </div>
            </div>
        </form>
    );
}

// default props
ProductVariationListItem.defaultProps = {
    item: {},
    cartQty: 0,
    setCartQty: () => {},
    addToCart: () => {},
    setButtonLoading: () => {},
};
// validate props
ProductVariationListItem.propTypes = {
    item: PropTypes.any.isRequired,
    cartQty: PropTypes.any.isRequired,
    setCartQty: PropTypes.func.isRequired,
    addToCart: PropTypes.func.isRequired,
    setButtonLoading: PropTypes.func.isRequired,
};

export default ProductVariationListItem;
